import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';

import { forkJoin, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { BoqModel, BrandModel, ChargeModel, ColourModel } from '../../../models';
import { BoqService } from '../../../services/boq.service';
import { BrandService } from '../../../services/brand.service';
import { ColourService } from '../../../services/colour.service';
import { ColourEditDialogConstants } from './common/colour-edit-dialog.constants';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { S3Service } from '../../../services/s3.service';

@Component({
	selector: 'app-colour-select-dialog',
	templateUrl: './colour-select-dialog.component.html',
	styleUrls: ['./colour-select-dialog.component.scss'],
})
export class ColourSelectDialogComponent implements OnInit {
	@Input() public charge: ChargeModel;
	@Input() public isDisabled = false;
	@Input() public projectId: string;

	public brands: BrandModel[] = [];
	public colour: ColourModel;
	public colourBrandId: string;
	public colours: ColourModel[] = [];
	public filteredColours = [];
	public isAdmin = false;
	public loading: boolean = false;
	public textConstants: typeof ColourEditDialogConstants = ColourEditDialogConstants;

	private destroyRef = inject(DestroyRef);

	constructor(
		private boqService: BoqService,
		private brandService: BrandService,
		private colourService: ColourService,
		private s3Service: S3Service,
	) {}

	public ngOnInit() {
		this.loading = true;
		forkJoin({
			colours: this.colourService.postList({ isActive: true }),
			brands: this.brandService.postList({ isActive: true })
		}).pipe(takeUntilDestroyed(this.destroyRef),
			tap(({ colours, brands }) => {
				this.colours = colours;
				this.brands = brands
				if (this.charge && this.charge.colour) {
					this.filterColourByBrand(this.charge.colour.brand);
					this.colourBrandId = this.charge.colour.brand;
					this.colour = new ColourModel(this.charge.colour);
				}
				this.loading = false;
			})).subscribe();
	}

	public onSave(): Observable<BoqModel> {
		let colourId;
		if (this.colour?.id) {
			colourId = this.colour.id;
		}

		return this.boqService.editColourBoq(this.charge.id, this.projectId, colourId);
	}

	/**
	 * Load Colour from the selected Brand
	 * @param {string} brandId
	 */
	public selectColourBrand(brandId: string): void {
		this.filterColourByBrand(brandId);
		this.colour = null;
	}

	private filterColourByBrand(brandId: string): void {
		this.filteredColours = this.colours.filter(colour => {
			return colour.brand === brandId;
		});
	}

	public getColourImage() {
		if (this.colour?.fileKey) {
			this.s3Service.getSignedUrl(this.colour.fileKey).pipe(
				takeUntilDestroyed(this.destroyRef))
				.subscribe(url => {
					this.colour.fileUrl = url;
				})
		}
	}
}
